'use client';

import { useEffect } from 'react';
import { useIsFullscreen } from '@/shared/providers/fullscreen-provider/store';

export const HeaderVisibilityController = () => {
  const isFullscreen = useIsFullscreen();

  useEffect(() => {
    const header = document.querySelector('[data-server-header="true"]');

    if (!header) {
      return;
    }

    header.toggleAttribute('hidden', isFullscreen);

    return () => {
      header.removeAttribute('hidden');
    };
  }, [isFullscreen]);

  return null;
};
